// Format display values only; retain full precision for billing and meter data.
export function formatMeasurement(value, locale = 'en') {
  if (value == null || value === '' || !Number.isFinite(Number(value))) return '—';
  return new Intl.NumberFormat(locale, {
    maximumFractionDigits: 3,
    useGrouping: false,
  }).format(Number(value));
}
